module.exports = __webpack_public_path__ + "static/media/BG_22.e5446eee.png";